// page-member ページのjs
import htmx from "htmx.org";
import { Tab } from "../modules/_tab";
import "../sass/page-member.scss";

const tabFn = () => {
  const roots = document.querySelectorAll(".js-tab");
  if (roots.length === 0) return;
  roots.forEach((root) => {
    const t = new Tab(root);
    t.init();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  // tabFn();
});

// ▼▼▼▼▼ DOMが安定した後に実行
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
let LOADED_COUNT = 0;
htmx.on("htmx:afterSettle", () => {
  LOADED_COUNT += 1;

  if (HTMX_ELM_COUNT === LOADED_COUNT) {
    // ここにDOMが安定した後に実行したい処理を記述する
    // swiper();
    tabFn();
  }
});
// ▲▲▲▲▲
